import Amplify from 'aws-amplify'

const REQUIRED_ENVIROMENTS = [
  'REACT_APP_AWS_COGNITO_USERPOOL_ID',
  'REACT_APP_AWS_REGION',
  'REACT_APP_USER_POOL_WEB_CLIENT_ID',
  'REACT_APP_TYCHO_RPC_API',
  'REACT_APP_TYCHO_DOCUMENTS',
  'REACT_APP_MAPBOX_TOKEN',
]

function validateEnvironmentVariables() {
  const notDefinedVariables = REQUIRED_ENVIROMENTS.filter((variable) => process.env[variable] == null)
  if (notDefinedVariables.length > 0)
    throw new Error(`Required enviroment variables not set: \n ${notDefinedVariables.join('\n')}`)
}

export function getEnv(variable) {
  if (REQUIRED_ENVIROMENTS.indexOf(variable) > -1) return process.env[variable]
  throw new Error(`variable is not a valid enviroment variable.`)
}

export function getAmpligyConfig() {
  return {
    Auth: {
      userPoolId: getEnv('REACT_APP_AWS_COGNITO_USERPOOL_ID'),
      region: getEnv('REACT_APP_AWS_REGION'),
      userPoolWebClientId: getEnv('REACT_APP_USER_POOL_WEB_CLIENT_ID'),
    },
  }
}

function setAmplifyConfigure() {
  Amplify.configure(getAmpligyConfig())
}

export function setConfigurations() {
  validateEnvironmentVariables()
  setAmplifyConfigure()
}
